import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['subdomain'],
    },
    fallbackLng: 'en',
    debug: false,
    resources: {
      en,
    },
  });

i18n.on('languageChanged', lng => {
  document.documentElement.setAttribute('lang', lng);
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js